// extracted by mini-css-extract-plugin
export default {"appLogo":"Welcome_appLogo__VyGrW","app-logo-spin":"Welcome_app-logo-spin__B1uWw","appHeader":"Welcome_appHeader__QGG8k","appLink":"Welcome_appLink__pBWS0"};